module.exports = __webpack_public_path__ + "img/39.e24baa73.jpg";